/** Session cookie name — must match backend sessionConfig / app.mjs */
export const SESSION_COOKIE_NAME = 'smartsaas.sid';

/** Lightweight localStorage key for session metadata (not auth secrets) */
export const PERSISTENT_SESSION_META_KEY = 'smartsaas_session_meta';

/** Standard browser session — matches server default cookie maxAge */
export const STANDARD_SESSION_DAYS = 1;

/** Offline company/user context switch — must have opened that scope online within this window */
export const OFFLINE_COMPANY_SWITCH_TTL_MS =
	STANDARD_SESSION_DAYS * 24 * 60 * 60 * 1000;

/** Extended persistence when user opts in to "Stay signed in" */
export const REMEMBER_ME_SESSION_DAYS = 30;

/** Default on web: reduces login friction on personal devices; user can opt out */
export const DEFAULT_REMEMBER_ME = true;

export function sessionDaysForRememberMe(rememberMe: boolean): number {
  return rememberMe ? REMEMBER_ME_SESSION_DAYS : STANDARD_SESSION_DAYS;
}

export function computeSessionExpireAt(rememberMe: boolean): number {
  const days = sessionDaysForRememberMe(rememberMe);
  return Date.now() + days * 24 * 60 * 60 * 1000;
}
